"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ResumeSuspendListeners = require("../helpers/ResumeSuspendListeners");

/* eslint-disable promise/avoid-new */
var fileSystems = {};
(0, _ResumeSuspendListeners.addOnResumeListener)(function () {
  // reset fileSystem accesses
  fileSystems = {};
});
/**
 * The Cordova File Plugin is not yet working with ES6 promises but uses callbacks instead.
 * This class puts syntactic sugar around them.
 *
 * All param names and their orders are kept the same, though extra parameters like baseDir are sometimes added in the beginning.
 */

var FileSystemWrapper = /*#__PURE__*/function () {
  function FileSystemWrapper() {
    (0, _classCallCheck2["default"])(this, FileSystemWrapper);
  }

  (0, _createClass2["default"])(FileSystemWrapper, null, [{
    key: "requestFileSystem",
    value: function () {
      var _requestFileSystem = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var type,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _args.length > 0 && _args[0] !== undefined ? _args[0] : window.LocalFileSystem.PERSISTENT;

                if (!fileSystems[type]) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", fileSystems[type]);

              case 3:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.requestFileSystem(type, 0, function (fileSystem) {
                    fileSystems[type] = fileSystem;
                    resolve(fileSystem);
                  }, function (error) {
                    reject(error);
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function requestFileSystem() {
        return _requestFileSystem.apply(this, arguments);
      }

      return requestFileSystem;
    }()
  }, {
    key: "getDirectoryEntry",
    value: function () {
      var _getDirectoryEntry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(baseDir, foldername, options) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                  baseDir.getDirectory(foldername, options, function (dirEntry) {
                    resolve(dirEntry);
                  }, function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getDirectoryEntry(_x, _x2, _x3) {
        return _getDirectoryEntry.apply(this, arguments);
      }

      return getDirectoryEntry;
    }()
  }, {
    key: "getFileEntry",
    value: function () {
      var _getFileEntry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(baseDir, filename, options) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                  baseDir.getFile(filename, options, function (fileEntry) {
                    resolve(fileEntry);
                  }, function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getFileEntry(_x4, _x5, _x6) {
        return _getFileEntry.apply(this, arguments);
      }

      return getFileEntry;
    }()
  }, {
    key: "getPathPrefix",
    value: function () {
      var _getPathPrefix = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var type,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : window.LocalFileSystem.PERSISTENT;
                return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.requestFileSystem(type, 0, function (fileSystem) {
                    resolve(fileSystem.root.nativeURL);
                  }, function (error) {
                    reject(error);
                  });
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getPathPrefix() {
        return _getPathPrefix.apply(this, arguments);
      }

      return getPathPrefix;
    }()
  }, {
    key: "removeFile",
    value: function () {
      var _removeFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(fileEntry) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.remove(function () {
                    resolve();
                  }, function (error) {
                    console.log('remove file error', error);

                    if (error.code === window.FileError.NOT_FOUND_ERR) {
                      resolve();
                      return;
                    }

                    reject(error);
                  }, function () {
                    // file does not exist
                    resolve();
                  });
                  resolve();
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function removeFile(_x7) {
        return _removeFile.apply(this, arguments);
      }

      return removeFile;
    }()
  }, {
    key: "removeDirectory",
    value: function () {
      var _removeDirectory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(dirEntry) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new _promise["default"](function (resolve, reject) {
                  dirEntry.removeRecursively(function () {
                    resolve();
                  }, function (error) {
                    if (error.code === window.FileError.NOT_FOUND_ERR) {
                      resolve();
                      return;
                    }

                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function removeDirectory(_x8) {
        return _removeDirectory.apply(this, arguments);
      }

      return removeDirectory;
    }()
  }, {
    key: "moveDirectoryOrFile",
    value: function () {
      var _moveDirectoryOrFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(baseDir, dirOrFileEntry, newName) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new _promise["default"](function (resolve, reject) {
                  dirOrFileEntry.moveTo(baseDir, newName, function () {
                    resolve();
                  }, function (error) {
                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function moveDirectoryOrFile(_x9, _x10, _x11) {
        return _moveDirectoryOrFile.apply(this, arguments);
      }

      return moveDirectoryOrFile;
    }()
  }, {
    key: "copyDirectoryOrFile",
    value: function () {
      var _copyDirectoryOrFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(baseDirTo, fileEntry, newName) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", new _promise["default"](function (resolve, reject) {
                  fileEntry.copyTo(baseDirTo, newName, function () {
                    resolve();
                  }, function (error) {
                    console.log('copy file error', error);
                    reject(error);
                  });
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function copyDirectoryOrFile(_x12, _x13, _x14) {
        return _copyDirectoryOrFile.apply(this, arguments);
      }

      return copyDirectoryOrFile;
    }()
  }, {
    key: "getDirContent",
    value: function () {
      var _getDirContent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(dirEntry) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var reader = dirEntry.createReader();
                  reader.readEntries(function (entries) {
                    resolve(entries);
                  }, function (err) {
                    reject(err);
                  });
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getDirContent(_x15) {
        return _getDirContent.apply(this, arguments);
      }

      return getDirContent;
    }()
  }]);
  return FileSystemWrapper;
}();

var _default = FileSystemWrapper;
exports["default"] = _default;